import React, {useMemo} from 'react';
import {Image} from 'antd-mobile';
import {ReactComponent as RightPointedArrowIcon} from '@components/assets/icons/right-pointed-arrow.svg';
// import {Swiper, SwiperSlide} from 'swiper/react';
// import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import 'swiper/css';
// import { View } from 'react-native-reanimated/lib/typescript/Animated';

// 移除swiper

export interface HomeCategoryProps<T = any> {
  list: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  onRightClick?: () => void;
  icon: React.ReactNode;
  preIcon?: React.ReactNode;
  title: React.ReactNode;
  rightContent?: React.ReactNode;
  swiperSlideWidth?: number;
  swiperSlideClassName?: string;
}

const HomeCategory = <T,>({
  list,
  renderItem,
  icon,
  title,
  rightContent,
  swiperSlideWidth,
  swiperSlideClassName,
  onRightClick,
  preIcon,
}: HomeCategoryProps<T>) => {
  const renderIcon = useMemo(() => {
    return typeof icon === 'string' ? (
      <Image width={'1.75rem'} height={'1.75rem'} src={icon} />
    ) : (
      icon
    );
  }, [icon]);
  const renderTitle = useMemo(() => {
    return typeof title === 'string' ? (
      <span className="text-t1 text-base font-bold capitalize">{title}</span>
    ) : (
      title
    );
  }, [title]);
  const renderRightContent = useMemo(() => {
    return typeof rightContent === 'string' ? (
      <span className="text-t3 text-sm">{rightContent}</span>
    ) : (
      rightContent
    );
  }, [rightContent]);
  // const {calcActualSize} = useScreenSize();
  // console.log('list', list);
  if (list.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex flex-row justify-between items-center px-2">
        <div className="flex flex-row items-center gap-2">
          {renderIcon}
          {renderTitle}
          {preIcon}
        </div>
        {!!rightContent && (
          <div
            className="flex flex-row items-center gap-1"
            onClick={onRightClick}>
            {renderRightContent}
            <RightPointedArrowIcon />
          </div>
        )}
      </div>
      <div className="w-full ">
        <div className="flex flex-row gap-2 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
          {list?.map((item, index) => (
            <div
              key={index}
              className={swiperSlideClassName}
              style={{
                width: swiperSlideWidth,
                flex: 'none',
                minWidth: swiperSlideWidth,
              }}>
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      </div>

      {/* <Swiper
        slidesPerView={'auto'}
        spaceBetween={calcActualSize(8)}
        className="w-full px-2">
        {list.map((item, index) => (
          <SwiperSlide
            key={index}
            className={swiperSlideClassName}
            style={swiperSlideWidth ? {width: swiperSlideWidth} : {}}>
            {renderItem(item, index)}
          </SwiperSlide>
        ))}
      </Swiper> */}
    </div>
  );
};

export default HomeCategory;
